<div class="bg-surface-page h-screen overflow-hidden">
  <div class="flex h-full">
    <xemex-sidebar [collapsedMenu]="collapsedMenu"></xemex-sidebar>

    <main class="bg-surface-page w-fit sm:w-full flex flex-col overflow-hidden">
      <xemex-header-bar
        [searchValue]="searchValue"
        [searchPlaceholder]="'header.placeholderSearchHeader' | translate"
        [userName]="userName"
        [userAvatar]="userAvatar"
        [isLoading]="isLoading"
        [partners]="partners ?? []"
        [docsUrl]="DOCS_URL"
        (menuIconChange)="onMenuIconClicked()"
        (searchChange)="onSearch($event)"
        (logout)="onLogoutClicked()"
        (partnerSelect)="onPartnerClicked($event)"
        (profileClick)="onProfileClicked()"
        (aboutClick)="onAboutClicked()"
      ></xemex-header-bar>
      <div class="flex-1 min-h-0 overflow-auto page-content">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
